import React from 'react'
import { Container, FilledButton } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import SuccessIcon from 'assets/images/ln-icon-success-tick.svg'

const MessageDisplaySuccess = ({ show, message, onDismiss }) => {
  if (!show) return null
  return (
    <Container id="main-content" className="ln-u-soft-ends">
      <div className="ln-c-status-card ln-c-status-card--green">
        <div className="ln-o-flag">
          <div className="ln-o-flag__component">
            <svg
              className="ln-icon-success-tick ln-c-message-display-success-icon-alignment" role="presentation"
              viewBox="0 0 50 50"
            >
              <use xlinkHref={`#${SuccessIcon.id}`} />
            </svg>
          </div>
          <div className="ln-o-flag__body ln-u-push-left">
            <div className="ln-u-body-2">{message}</div>
          </div>
          <div className="ln-o-flag__component ln-o-flag__component--nowrap">
            <div className="ln-c-status-card__content">
              <FilledButton
                className="ln-c-button ln-c-button--large ln-c-button--primary ln-c-message-display-success-ok-button-alignment ln-o-flag__component--nowrap"
                onClick={onDismiss}
              >Ok, got it
              </FilledButton>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

MessageDisplaySuccess.propTypes = {
  message: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired
}

export default MessageDisplaySuccess



// WEBPACK FOOTER //
// ./src/components/MessageDisplaySuccess/index.jsx